import { cfetch } from '@confluence/network';

type DismissCurationOptions = {
	neverShowAgain?: boolean;
	remindTomorrow?: boolean;
	undoNeverShowAgain?: boolean;
};

export const useDismissCuration = (): {
	dismissAction: ({
		neverShowAgain,
		remindTomorrow,
		undoNeverShowAgain,
	}?: DismissCurationOptions) => Promise<void>;
} => {
	const dismissAction = async ({
		neverShowAgain = false,
		remindTomorrow = false,
		undoNeverShowAgain = false,
	}: DismissCurationOptions = {}): Promise<void> => {
		// Mutually exclusive params, matching backend precedence: undoNeverShowAgain > remindTomorrow > neverShowAgain.
		const params = undoNeverShowAgain
			? new URLSearchParams({ undoNeverShowAgain: 'true' })
			: remindTomorrow
				? new URLSearchParams({ remindTomorrow: 'true' })
				: new URLSearchParams({ neverShowAgain: String(neverShowAgain) });
		await cfetch(
			`/wiki/rest/internal/1.0/spaces/remote-objects/suggestions/dismiss?${params.toString()}`,
			{
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
			},
		);
	};

	return { dismissAction };
};
